import { ITransferPendingCoursesDatasource } from './../datasources/transfer_pending_courses_datasource';
import { ITransferCollegesDatasource } from './../datasources/transfer_colleges_datasource';
import { ITransferCoursesDatasource } from './../datasources/transfer_courses_datasource';
import { College } from './../builders/college_builder';
import { ICommand, IDefineCommand, IDatasource, IQueryMediator, IQuery } from 'core-ts-types';

angular
  .module('capability-ng-transfer')
  .factory(
    'deselectTransferCollegeCommand',
    (
      defineCommand: IDefineCommand,
      QueryMediator: IQueryMediator,
      ngTransferCollegesDatasource: ITransferCollegesDatasource,
      ngTransferCoursesDatasource: ITransferCoursesDatasource,
      ngTransferPendingCoursesDatasource: ITransferPendingCoursesDatasource,
      $http: ng.IHttpService,
      transferMajorTileDelegate: any
    ): ICommand => {
      return defineCommand('deselectTransferCollegeCommand', function deselectMajor(
        deferred: ng.IDeferred<IQuery[]>,
        college: College
      ): void {
        $http({
          method: 'DELETE',
          url: `student/college/${college.nk}/`
        })
          .then((response: ng.IHttpPromiseCallbackArg<any>): void => {
            const courses = _.filter(ngTransferCoursesDatasource.read(), (course) => course.college_nk === college.nk);
            if (!_.isEmpty(courses)) {
              transferMajorTileDelegate.updateDegreeAudit();
              _.each(courses, ngTransferCoursesDatasource.del, ngTransferCoursesDatasource);
            }
            const pendingCourses = _.filter(
              ngTransferPendingCoursesDatasource.read(),
              (course) => course.college_nk === college.nk
            );
            _.each(pendingCourses, ngTransferPendingCoursesDatasource.del, ngTransferPendingCoursesDatasource);

            ngTransferCollegesDatasource.del(college);

            deferred.resolve(QueryMediator.runQueries(ngTransferCollegesDatasource, ngTransferCoursesDatasource));
          })
          .catch(deferred.reject);
      });
    }
  );



// WEBPACK FOOTER //
// ./app/lib/transfer/commands/deselect_transfer_college_command.ts